export const pageScrollHandler = () =>{
    return window.location.href.includes('how-it-works') || window.location.href.includes('privacy-policy') || window.location.href.includes('user-agreement') || window.location.href.includes('public-presale');
}